import { createSelector } from '@reduxjs/toolkit';
import { ApplicationSDKState } from 'sdk/interfaces/sdkInterface';

import { sliceName } from './blogConfig';
import { BlogState } from './blogInterface';

export const sliceSelector = (state: ApplicationSDKState) => {
    return state[sliceName];
};

export const blogErrorsSelector = createSelector(sliceSelector, (slice: BlogState) => {
    return slice.error;
});

export const blogsSelector = createSelector(sliceSelector, (slice: BlogState) => {
    return slice.blogs;
});